/** 쿠키 이름. authKey 는 빌드별로 바꿀 수 있다 — 광해 데모 빌드(.env.komir)는 authKey_komir 로 콘엑스 로그인과 분리. */
export const Cookies = {
  loginId: "loginId",
  authKey: process.env.REACT_APP_AUTH_COOKIE || "authKey",
  clientId: "id",
  mainModal: "mainModal",
} as const;
